import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Grid, Typography, AccordionDetails } from "@mui/material";
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { styled } from "@mui/material/styles";
import { ChevronDown } from "mdi-material-ui";
import { marked } from "marked";
import CustomAccordion from '../Accordion';
const renderer = {
    link: (href, title, text) => `<a target="_blank" href="${href}" title="${title}">${text}</a>`,
};
marked.use({ renderer });
const createMarkup = (htmlString) => {
    return { __html: htmlString };
};
const valueRenderer = (value) => {
    switch (typeof value) {
        case "number":
            return _jsx("span", { children: value });
        case "object":
            if (Array.isArray(value)) {
                return value.map((tag) => _jsx("span", { children: tag }, tag));
            }
            else {
                return _jsx("span", { children: value });
            }
        case "string":
            const htmlString = marked.parseInline(value.toString());
            return _jsx("span", { dangerouslySetInnerHTML: createMarkup(htmlString) });
    }
};
const AccordionSummary = styled((props) => (_jsx(MuiAccordionSummary, Object.assign({ expandIcon: _jsx(ChevronDown, { color: "primary" }) }, props))))(({ theme }) => ({
    backgroundColor: '#F5F4FC',
    padding: '0px 16px',
    height: '38px !important',
    minHeight: '38px !important',
}));
function InfoAccordion({ data, title }) {
    return (_jsxs(CustomAccordion, Object.assign({ defaultExpanded: true, sx: { mt: 3, boxShadow: 'none' } }, { children: [_jsx(AccordionSummary, Object.assign({ expandIcon: _jsx(ChevronDown, { color: "primary" }), "aria-controls": "panel1a-content", id: "panel1a-header" }, { children: _jsx(Typography, Object.assign({ variant: "h4", textTransform: "capitalize", fontWeight: 500 }, { children: title })) })), _jsx(AccordionDetails, Object.assign({ sx: { p: '16px' } }, { children: _jsx(Box, Object.assign({ sx: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gridGap: '16px 40px',
                        alignItems: 'start',
                        width: '100%',
                        a: { textDecoration: 'none' },
                    } }, { children: data.length > 0 ? (data === null || data === void 0 ? void 0 : data.map((info, idx) => (_jsxs(Box, { children: [_jsxs(Grid, Object.assign({ container: true, spacing: 2, mb: 4 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: info.key })) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Typography, Object.assign({ variant: "h5", textAlign: "end" }, { children: valueRenderer(info.value) })) }))] })), _jsx(Divider, {})] }, idx)))) : (_jsx(Typography, { children: "No Data Available" })) })) }))] })));
}
export default InfoAccordion;
